import {React} from 'common'
import {Loading, Page} from 'components/Page'
import DanceRequestList from 'components/UserPendingDancesRequests/DanceRequestList'
import styled from 'styled-components'
import {Colors} from 'appearance'
import useUserPendingDancesRequests from 'logic/Dance/useUserPendingDancesRequests.js'

const UserPendingDancesRequests = () => {
    const {pendingDances, dancesSuccess, pageTitle, t} =
        useUserPendingDancesRequests()

    console.log(pendingDances)
    if (!dancesSuccess) {
        return (
            <Loading
                pageTitle={pageTitle}
                loadingText={t('loading')}
                isLoading={!dancesSuccess}
            />
        )
    }

    if (!pendingDances?.length > 0) {
        return (
            <Page title={pageTitle}>
                <NoDances>{t('noRequests')}</NoDances>
            </Page>
        )
    }

    return (
        <Page title={pageTitle}>
            {pendingDances.map((dance) => (
                <DanceRequestList
                    key={`dance_requests_${dance?.name}`}
                    dance={dance}
                    t={t}
                />
            ))}
        </Page>
    )
}

export default UserPendingDancesRequests

const NoDances = styled.h3`
    font-size: 24px;
    color: ${Colors.BLUE};
`
